import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import { FachschluesselNumber, ZusatzoptionItem } from '@ps20-frontend/frontend-models';
import { IAppState } from '../../../store/appState';

export const selectAnzahlWohnungen = (state: IAppState): number => {
  const zusatzoptionWohnungen = getSelectedProduktlinie(state.produkt).zusatzoptionen.find(
    (zusatzoption: ZusatzoptionItem) =>
      zusatzoption.fachschluessel === FachschluesselNumber.WOHNUNSHAFTPFLICHT,
  );
  return zusatzoptionWohnungen === undefined || !zusatzoptionWohnungen.isSelected
    ? 0
    : state.anzahlWohnungen;
};

export const selectAnzahlWohnungenEingabe = (state: IAppState): number => {
  return state.anzahlWohnungen;
};
